
<template>
  <v-container fluid class="ma-0 pa-0 pre-footer">
    <!-- DESKTOP -->
    <div class="d-none d-lg-block">
      <v-row class="ma-0 pa-8 primary">
        <v-col cols="12" md="5">
          <v-container
            fluid
            fill-height
            class="d-flex justify-center text-h4 text-white"
            style="font-family: Montserrat; white-space: pre-line;"
          >
            <table>
              <tbody>
                <tr>
                  <td>
                    {{ $t('footer.ideas1') }}<br />
                    {{ $t('footer.ideas2') }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <v-btn
                      rounded
                      block
                      color="info"
                      variant="flat"
                      class="font-weight-light"
                      @click="goContacts"
                    >
                      {{ $t('footer.send') }}
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-container>
        </v-col>

        <v-col cols="12" md="2">
          <v-container fluid>
            <div class="align-center">
              <v-img
                src="@/assets/covers/icon_P BRANCO 1.png"
                max-width="125px"
                style="display: block; margin-left: auto; margin-right: auto;"
              />
            </div>
          </v-container>
        </v-col>

        <v-col cols="12" md="5">
          <v-container
            fluid
            fill-height
            class="d-flex justify-center text-white"
            style="white-space: pre-line;"
          >
            <table>
              <tbody>
                <tr>
                  <td></td>
                  <td>
                    <div class="text-h5 font-weight-bold">
                      {{ $t('PRE_FOOTER.contacts') }}
                    </div>
                  </td>
                </tr>
                <tr
                  class="text-h6 font-weight-light"
                  style="font-family: Montserrat;"
                >
                  <td><v-icon color="white">mdi-email</v-icon></td>
                  <td>info@dreamdealtech.com</td>
                </tr>
                <tr
                  class="text-h6 font-weight-light"
                  style="font-family: Montserrat;"
                >
                  <td><v-icon color="white">mdi-clock</v-icon></td>
                  <td>
                    {{ $t('PRE_FOOTER.work_week') }}
                    - 9h {{ $t('PRE_FOOTER.to') }} 18h
                  </td>
                </tr>
                <tr
                  class="text-h6 font-weight-light"
                  style="font-family: Montserrat;"
                >
                  <td><v-icon color="white">mdi-phone</v-icon></td>
                  <td>+351 220 280 430</td>
                </tr>
              </tbody>
            </table>
          </v-container>
        </v-col>
      </v-row>
    </div>

    <!-- MOBILE -->
    <v-row class="d-lg-none ma-0 pa-2 accent">
      <v-col cols="12">
        <v-container
          fluid
          fill-height
          class="d-flex justify-center text-h6 text-center text-white"
          style="white-space: pre-line;"
        >
          {{ $t('footer.ideas1') }}<br />
          {{ $t('footer.ideas2') }}
        </v-container>
      </v-col>

      <v-col cols="12">
        <v-container fluid class="d-flex justify-center">
          <v-img
            max-width="100px"
            src="@/assets/covers/icon_P BRANCO 1.png"
          />
        </v-container>
      </v-col>

      <v-col cols="12">
        <v-container
          fluid
          fill-height
          class="d-flex justify-center text-center text-white"
          style="white-space: pre-line;"
        >
          <table>
            <tbody>
              <tr>
                <td></td>
                <td>
                  <div class="text-body-1 font-weight-medium">
                    {{ $t('PRE_FOOTER.contacts') }}
                  </div>
                </td>
              </tr>
              <tr class="text-caption font-weight-light">
                <td>
                  <v-icon color="white" class="mr-2">
                    mdi-email
                  </v-icon>
                </td>
                <td>info@dreamdealtech.com</td>
              </tr>
              <tr class="text-caption font-weight-light">
                <td>
                  <v-icon color="white" class="mr-2">
                    mdi-clock
                  </v-icon>
                </td>
                <td>
                  {{ $t('PRE_FOOTER.work_week') }}
                  - 9h {{ $t('PRE_FOOTER.to') }} 18h
                </td>
              </tr>
              <tr class="text-caption font-weight-light">
                <td>
                  <v-icon color="white" class="mr-2">
                    mdi-phone
                  </v-icon>
                </td>
                <td>+351 220 280 430</td>
              </tr>
            </tbody>
          </table>
        </v-container>
      </v-col>
    </v-row>

    <!-- BARRA PRR - FUNDO ESCURO -->
    <div class="prr-financing-bar">
      <a
        href="https://recuperarportugal.gov.pt/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Plano de Recuperação e Resiliência - Recuperar Portugal"
        class="prr-financing-link"
      >
        <img
          :src="prrLogo"
          alt="PRR, República Portuguesa e Financiado pela União Europeia - NextGenerationEU"
          class="prr-financing-image"
        />
      </a>
    </div>
  </v-container>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

import prrLogo from '@/assets/p2020/BARRA_FINANCIAMENTO/PNG/BARRA_LOGOS-03.png'

const router = useRouter()
const { locale } = useI18n({ useScope: 'global' })

function goContacts() {
  router.push({
    name: 'contacts',
    params: {
      lang: String(locale.value || 'pt')
    }
  })
}
</script>

<style scoped>
.pre-footer {
  background-color: #0D1F2B;
}

/* BARRA DE FINANCIAMENTO PRR */
.prr-financing-bar {
  background-color: #0D1F2B;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 16px 24px;
}

.prr-financing-link {
  display: block;
  width: min(100%, 600px);
  line-height: 0;
  cursor: pointer;
}

.prr-financing-image {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}

@media (max-width: 600px) {
  .prr-financing-bar {
    padding: 16px;
  }

  .prr-financing-link {
    width: 100%;
  }
}
</style>
